module.exports = {
    get Navigation() {
        return require('./Navigation').default
    }
}

